// eslint-disable-next-line no-restricted-imports
import { format } from 'date-fns';

import { toDateInClientTimezone } from '../../../utils/admin';
import { DateTimeDisplayMode } from '../constants/DateTimeDisplayMode';
import { FORMAT_MAP } from '../constants/formatMap';

export const formatDateTime = (
  value: Date | string,
  mode: DateTimeDisplayMode,
): string => {
  const date = toDateInClientTimezone(value);
  return format(date, FORMAT_MAP[mode]);
};
